// Localidades — must match wa-cloud-bridge/src/utils/localidad.js
export const LOCALIDADES = {
  1: "Madryn",
  2: "Trelew",
  3: "Rawson",
  4: "Gaiman",
  5: "Comodoro",
  6: "Pico Truncado",
  7: "Las Heras",
  8: "Casilda",
  9: "Dolavon",
  10: "Carcaraña",
  11: "Caleta Olivia",
  12: "El Calafate",
};

export const LOCALIDADES_OPTIONS = Object.entries(LOCALIDADES).map(([id, nombre]) => ({
  id: parseInt(id, 10),
  nombre,
}));

export const FAQ_CATEGORIES = [
  { id: "general",     label: "General",              icon: "📋" },
  { id: "soporte",     label: "Soporte técnico",       icon: "🔧" },
  { id: "facturacion", label: "Facturación",            icon: "💳" },
  { id: "ventas",      label: "Ventas",                icon: "🛒" },
  { id: "retencion",   label: "Retención",             icon: "🎁" },
  { id: "otros",       label: "Otros",                 icon: "📁" },
  { id: "system",      label: "Sistema (no editar)",   icon: "⚙️", isSystem: true },
];

export const DAY_KEYS = ["monday","tuesday","wednesday","thursday","friday","saturday","sunday"];

export const DAY_LABELS = {
  monday:    "Lunes",
  tuesday:   "Martes",
  wednesday: "Miércoles",
  thursday:  "Jueves",
  friday:    "Viernes",
  saturday:  "Sábado",
  sunday:    "Domingo",
};

export const DEFAULT_SCHEDULE_TEMPLATE = {
  timezone: "America/Argentina/Buenos_Aires",
  afterHoursMessage:
    "Estamos fuera de horario de atención. Nuestro equipo responde de lunes a viernes de 09:00 a 18:00. Te respondemos {{nextWindow}}.",
  schedule: DAY_KEYS.reduce((acc, day) => {
    acc[day] = {
      enabled: ["monday","tuesday","wednesday","thursday","friday"].includes(day),
      start: "09:00",
      end: "18:00",
    };
    return acc;
  }, {}),
  holidays: [],
};

export function normalizeSchedule(payload) {
  const base = payload && typeof payload === "object" ? payload : {};
  const result = {
    timezone: base.timezone || DEFAULT_SCHEDULE_TEMPLATE.timezone,
    afterHoursMessage: base.afterHoursMessage || DEFAULT_SCHEDULE_TEMPLATE.afterHoursMessage,
    schedule: {},
    holidays: Array.isArray(base.holidays) ? [...base.holidays] : [],
  };
  DAY_KEYS.forEach((day) => {
    const raw = base.schedule?.[day];
    const defaults = DEFAULT_SCHEDULE_TEMPLATE.schedule[day];
    result.schedule[day] = {
      enabled: raw?.enabled === undefined ? defaults.enabled : Boolean(raw.enabled),
      start: raw?.start || defaults.start,
      end: raw?.end || defaults.end,
    };
  });
  result.holidays.sort();
  return result;
}

export function createScheduleDefaults() {
  return normalizeSchedule(DEFAULT_SCHEDULE_TEMPLATE);
}

// Sidebar navigation structure
export const SIDEBAR_GROUPS = [
  {
    id: "bot",
    label: "Configuración del bot",
    items: [
      { id: "bot_messages",     label: "Mensajes y textos",   sectionKeys: ["config", "messages", "post_identification_menu"] },
      { id: "limits",           label: "Límites del sistema", sectionKeys: ["limits"] },
      { id: "support_schedule", label: "Horario de atención", sectionKeys: ["support_schedule"] },
    ],
  },
  {
    id: "commercial",
    label: "Contenido comercial",
    items: [
      { id: "pricebook",        label: "Planes — Prospectos", sectionKeys: ["pricebook"] },
      { id: "pricebook_active", label: "Planes — Clientes",   sectionKeys: ["pricebook_active"] },
      { id: "retention_promos", label: "Promos de retención", sectionKeys: ["retention_promos"] },
      { id: "localidades",      label: "Localidades",          sectionKeys: ["localidades"] },
    ],
  },
  {
    id: "intelligence",
    label: "Inteligencia del bot",
    items: [
      { id: "keywords", label: "Palabras clave", sectionKeys: ["keywords"] },
      { id: "intents",  label: "Intents",         sectionKeys: ["intents"] },
      { id: "faqs",     label: "FAQs",            sectionKeys: ["faqs"] },
    ],
  },
  {
    id: "agents",
    label: "Panel de agentes",
    items: [
      { id: "suggestions", label: "Sugerencias", sectionKeys: ["suggestions"] },
      { id: "flows",       label: "Flujos",       sectionKeys: ["flows"] },
    ],
  },
  {
    id: "analytics",
    label: "Analítica",
    items: [
      { id: "metrics_keywords", label: "Palabras de métricas", sectionKeys: ["metrics_keywords"] },
    ],
  },
];

export const SECTION_LABELS = SIDEBAR_GROUPS.flatMap((g) => g.items).reduce(
  (acc, item) => ({ ...acc, [item.id]: item.label }),
  {}
);
